import React from 'react';

import { Box } from 'ui/box';

interface LessonIndicatorProps {
  currentLessonNumber: number;
  totalLessons: number;
}

const LessonIndicator = ({
  currentLessonNumber,
  totalLessons,
}: LessonIndicatorProps): React.JSX.Element => (
  <Box
    sx={{
      mb: 1,
      color: 'tokens.navy.500',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: 600,
    }}
  >
    Lesson {currentLessonNumber + 1} of {totalLessons}
  </Box>
);

export default LessonIndicator;
